<template>

  <div v-if="showTable">
    
    <!-- Toolbar da data table -->
    <v-toolbar flat>
      <v-toolbar-title class="headline font-weight-light">Convenção Coletiva</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-text-field v-model="search" append-icon="search" label="Pesquisar" single-line hide-details></v-text-field>
      <v-spacer></v-spacer>
      <v-btn :disabled="loading" :loading="loading" :color="loading ? 'info' : 'info'" icon
        title="Inserir um novo registro" @click="addColletiveConvention();">
        <v-icon>add</v-icon>
      </v-btn>
    </v-toolbar>
    <!-- TABELA -->
    <v-data-table :loading="loading" :headers="headersConvention" :search="search" :items="conventions" hide-actions
      class="elevation-1">
      <template slot="items" slot-scope="props">
        <td class="text-xs-center">{{ props.item.year }}</td>
        <td class="text-xs-center">{{ props.item.code || null}}</td>
        <td class="text-xs-center">
          <v-chip small class="white--text font-weight-light"
            :color="props.item.active == false ? 'error' : 'success lighten-1' " :disabled="props.item.active == false">
            {{props.item.active == false ? 'Inativa' : 'Ativa'}}</v-chip>
        </td>
        <td class="justify-center layout px-0 text-xs-center">
          <v-btn icon round flat title="Editar" @click="edit(props.item);" color="info" :disabled="loading">
            <v-icon color="info">edit</v-icon>
          </v-btn>
        </td>
      </template>
      <div slot="no-results" :value="true">
        <h3 class="text-xs-center">{{emptySearchText}} "{{ search }}".</h3>
      </div>
      <template slot="footer" v-if="conventions.length > 0">
        <td colspan="100%">
          <strong> {{ footerText }} {{ conventions.length }} </strong>
        </td>
      </template>

      <template slot="no-data" v-else>
        <strong> {{footerDynamicText}} </strong>
      </template>
    </v-data-table>
  </div>
  <div v-else>
    <!-- DADOS DA CONVÊNÇÃO -->
    <v-form ref="formConvention" lazy-validation>


      <v-toolbar dark color="primary">
        <v-btn icon dark @click.prevent="cancelNewConvention();" title="Cancelar">
          <v-icon>close</v-icon>
        </v-btn>
        <v-toolbar-title>Convenção Coletiva</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn @click.prevent="save();" title="Salvar" color="primary" small depressed>
            Salvar
            <v-icon right>save</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>

      <v-container fluid grid-list-xl>

        <v-layout row wrap justify-space-between>

          <v-flex xs4 sm3>
            <v-text-field v-model="convention.year" :rules="inputRules" box label="Ano da Convenção"></v-text-field>
          </v-flex>
          <v-flex xs8 sm3>
            <v-text-field v-model="convention.code" :rules="inputRules" box label="Código da Convenção"></v-text-field>
          </v-flex>
          <v-flex xs8 sm3>
            <v-text-field v-model="convention.dataBaseOfTheCategory" type="date" :rules="inputRules" box label="Data Base da Categoria"></v-text-field>
          </v-flex>
          <v-flex xs8 sm3>
            <v-currency-field box label="Salário Mínimo (R$)" v-bind="currency_config"
              v-model="convention.minimalSalary">
            </v-currency-field>
          </v-flex>
          <v-flex xs12>
            <v-text-field v-model="convention.description" box label="Descrição"></v-text-field>
          </v-flex>
        </v-layout>
      </v-container>
      <!-- LISTAGEM DE ITENS DA CONVENÇÂO -->
      <v-container fluid py-0>
        <v-toolbar flat card>
          <v-toolbar-title class="font-weight-light">Itens da Convenção</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn :disabled="loading" :loading="loading" slot="activator" color="info" round icon class="mb-2"
              @click="newItem();">
              <v-icon>add</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>

        <v-data-table :loading="loading" :headers="headers" :items="convention.items" hide-actions class="elevation-1">
          <template slot="items" slot-scope="props">
            <td class="text-xs-center">{{ props.item.occupation.name }}</td>
            <td class="text-xs-center">{{ maskCBO(props.item.occupation.code) }}</td>
            <td class="text-xs-center">{{ props.item.basicSalary | currency }}</td>
            <td class="text-xs-center">{{ sumOfCosts(props.item.costs) | currency}}</td>
            <td class="justify-center layout px-0 text-xs-center">
              <v-btn :disabled="loading" title="Editar Item" color="info" flat icon @click="editItem(props.item);">
                <v-icon color="info">edit</v-icon>
              </v-btn>
            </td>
          </template>

          <template slot="footer" v-if="convention.items.length>0">
            <td colspan="100%">
              <strong class="font-weight-light"> Total de itens da Convenção: {{ convention.items.length }} </strong>
            </td>
          </template>



          <template slot="no-data" v-else>

            <strong v-if="quantityItemsError" class="red--text">Adicione pelo menos 1 item</strong>
            <strong v-else-if="!quantityItemsError"> {{dynamicFooterText}} </strong>
          </template>
        </v-data-table>
      </v-container>

      <!-- LISTAGEM DE GRATIFICAÇÃO POR POSTO DE SERVIÇO DA CONVENÇÂO -->
      <v-container fluid>
        <v-toolbar flat card>
          <v-toolbar-title class="font-weight-light">Gratificações de Posto de Serviços</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn :disabled="loading" :loading="loading" slot="activator" color="info" round icon class="mb-2"
              @click="newServiceStation();">
              <v-icon>add</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>

        <v-data-table :loading="loading" :headers="headersServiceStations" :items="serviceStations" hide-actions
          class="elevation-1">
          <template slot="items" slot-scope="props">
            <td class="text-xs-center">
              {{ props.item.description }}</td>
            <td class="text-xs-center">{{ props.item.value | currency }}</td>
            <td class="justify-center layout px-0 text-xs-center">
              <v-btn :disabled="loading" title="Editar Item" color="info" flat icon
                @click="editServiceStation(props.item);">
                <v-icon color="info">edit</v-icon>
              </v-btn>
            </td>
          </template>

          <template slot="footer" v-if="convention.serviceStations.length>0">
            <td colspan="100%">
              <strong class="font-weight-light"> Total de Postos de Serviços: {{ convention.serviceStations.length }}
              </strong>
            </td>
          </template>

          <template slot="no-data" v-else>
            <strong> {{dynamicFooterText}} </strong>
          </template>
        </v-data-table>
      </v-container>

      <!-- DIALOG DE ITEM -->
      <v-dialog v-model="showDialogItem" persistent max-width="600">
        <v-card>
          <v-toolbar color="white" class="elevation-1">
            <v-toolbar-title class="black--text font-weight-light">Nova Função da Convenção</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn :disabled="loading" flat color="error" icon round @click.native="cancelNewItem()">
                <v-icon large color="error">clear</v-icon>
              </v-btn>
            </v-toolbar-items>
          </v-toolbar>

          <v-card-text>
            <v-form lazy-validation ref="formDialogFunctionConvention">
              <v-autocomplete label="Ocupação" v-model="item.occupation" item-value="code" :items="CBOs"
                    :item-text="occupationText" return-object dense box :rules="inputRules"></v-autocomplete>
              
              <v-checkbox
                v-if="item.occupation"
                v-model="item.occupation.commissioner"
                label="É encarregado?"
                persistent-hint
                :hint="item.occupation.commissioner ? 'Sim': 'Não'"
                class="mt-0 mb-3"
              ></v-checkbox>

              <v-currency-field box label="Salário Base (R$)" v-bind="currency_config" :rules="inputRules"
                v-model="item.basicSalary">
              </v-currency-field>

              <v-toolbar flat card>
                <v-toolbar-title class="font-weight-light">Gratificações</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-tooltip bottom>
                  <v-btn :disabled="loading" :loading="loading" small icon round color="info" slot="activator"
                    @click="newCost();">
                    <v-icon color="white">add</v-icon>
                  </v-btn>
                  <span>Adicionar gratificação</span>
                </v-tooltip>
              </v-toolbar>
              <v-data-table :loading="loading" :headers="headersDataTableCosts" :items="costs" hide-actions
                class="elevation-1">
                <template slot="items" slot-scope="props">
                  <td class="text-xs-center">
                    {{ props.item.description }}</td>
                  <td class="text-xs-center">{{ props.item.value | currency }}</td>
                  <td class="text-xs-center">{{ props.item.observation }}</td>
                  <td class="justify-center layout px-0 text-xs-center">
                    <v-btn :disabled="loading" icon flat color="error" @click="removeCost(props.item);">
                      <v-icon small>
                        delete
                      </v-icon>
                    </v-btn>
                  </td>
                </template>
                <template slot="footer" v-if="costs.length > 0">
                  <td colspan="100%">
                    <strong> {{ footerText }} {{ costs.length }} </strong>
                  </td>
                </template>
                <template slot="no-data" v-else>
                  <strong> Nenhum registro encontrado! </strong>
                </template>
              </v-data-table>
            </v-form>
          </v-card-text>
          <v-card-actions class="pb-3">
            <v-btn :disabled="loading" :loading="loading" block round color="success lighten-1"
              @click.native="addItem();">Salvar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- DIALOG DE CUSTO -->
      <v-dialog v-model="showDialogCost" persistent max-width="600">
        <v-card>
          <v-toolbar dark color="white" class="black--text">
            <v-toolbar-title class="font-weight-light">Gratificação</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>

              <v-btn :disabled="loading" flat color="error" icon dark @click.native="cancelNewCost()">
                <v-icon large color="error">clear</v-icon>
              </v-btn>
            </v-toolbar-items>
          </v-toolbar>
          <v-card-text>
            <v-form lazy-validation ref="formDialogCost">
              <v-text-field box label="Descrição" :rules="inputRules" v-model="cost.description"></v-text-field>
              <v-currency-field box class="currency-prepend-outer-icon" :rules="inputRules" label="Valor (R$)"
                v-bind="currency_config" v-model="cost.value">
              </v-currency-field>
              <v-text-field box label="Observação" v-model="cost.observation"></v-text-field>
            </v-form>
          </v-card-text>
          <v-card-actions class="pb-3">
            <v-btn :disabled="loading" :loading="loading" block round color="success lighten-1"
              @click.native="addCost();">Salvar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- DIALOG DE POSTO DE SERVIÇO -->
      <v-dialog v-model="showDialogServiceStation" persistent max-width="600">
        <v-card>
          <v-toolbar color="white" class="elevation-1">
            <v-toolbar-title class="black--text font-weight-light">Posto de Serviço</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn title="Cancelar" @click.native="closeDialogServiceStation();" :disabled="loading" flat color="error"
              icon round>
              <v-icon large color="error">clear</v-icon>
            </v-btn>

          </v-toolbar>

          <v-form ref="formServiceStation" lazy-validation>
            <v-card-text class="pb-0">

              <v-text-field label="Descrição" :rules="inputRules" v-model="serviceStation.description" box>
              </v-text-field>
              <v-currency-field box label="Valor(R$)" :rules="inputRules" v-bind="currency_config"
                v-model="serviceStation.value">
              </v-currency-field>
              <v-text-field label="Observação" v-model="serviceStation.observation" box></v-text-field>

            </v-card-text>
            <v-card-actions class="pb-3">
              <v-btn :disabled="loading" :loading="loading" block round color="success lighten-1"
                @click.native="addServiceStation();">Salvar
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-dialog>

      <v-snackbar v-model="snackbar.visible" :color="snackbar.color" multi-line :timeout="snackbar.timeout" vertical
        right button>
        <strong>{{snackbar.title}}</strong> {{ snackbar.subtitle }}
        <v-btn dark flat @click="snackbar.visible = false">
          Fechar
        </v-btn>
      </v-snackbar>
    </v-form>
  </div>
</template>

<script>
  // SERVICES //
  import CBO from './../data/CBO'
  import CollectiveConventionService from "../service/CollectiveConventionService";
  import Headers from './../data/headers/CollectiveConventionHeaders'

  // COMPONENTES //
  import FormServiceStation from "../components/collective_convention/FormServiceStation";

  import {
    mapActions
  } from "vuex";
  import {
    constants
  } from 'crypto';
import Currency from '../utils/Currency';

  export default {
    components: {
      FormServiceStation
    },

    data: () => ({
      showDialogColletiveConvention: false,
      showTable: true,
      isEdition: false,
      search: '',
      year: {},
      title: '',
      CBOs: [],
      conventions: [],
      convention: {},
      serviceStation: {},
      conventionDefault: {
        year: "",
        code: "",
        description: "",
        items: [],
        serviceStations: []
      },
      index: "",

      editingServiceStation: false,

      // Visual //

      loading: false,
      quantityItemsError: false,

      currency_config: Currency.real,
      // DATA TABLE //
      showDataTable: false,
      items: [],

      snackbar: {
        visible: false,
        title: "",
        subtitle: "",
        color: "",
        timeout: 6000
      },

      // POSTO DE SERVIÇO //
      showDialogServiceStation: false,
      serviceStations: [],
      indexServiceStationSelected: {},

      // ITEM DA CONVENÇÃO //
      item: {},
      costs: [],
      showDialogItem: false,

      // CUSTOS //
      cost: {},
      showDialogCost: false,
      isEditingServiceStation: false,
      // QUANDO NÃO TIVER FUNÇÃO CADASTRADA //
      showDialogNoFunction: false,

      /**********\
      ***Rules***
      \**********/
      inputRules: [
        v => !!v || 'Campo obrigatório',
      ],
      //Headers
      headers: [],
      headersConvention: [],
      headersServiceStations: [],
      headersDataTableCosts: [],

      emptySearchText: "Nenhuma convenção encontrada para",
      footerText: "Total de registros: "
    }), // data

    computed: {
      dynamicFooterText(teste) {
        let text =
          `${
        this.loading
          ? "Carregando items registrados..."
          : "Nenhum item registrado para a Convenção."
      }`;
        return text;
      },
      footerDynamicText() {
        let text = this.loading ? this.loadingRecordsText : this.emptyRecordsText;
        return text
      }
    },
    async beforeMount() {
      await this.getHeaders()
      await this.getCBOs()
    },

    methods: {
      getHeaders() {
        this.headers = Headers.getHeaders();
        this.headersConvention = Headers.getHeadersConvention();
        this.headersServiceStations = Headers.getHeadersServiceStations();
        this.headersDataTableCosts = Headers.getHeadersDataTableCosts();
      },
      getCBOs() {
        this.CBOs = CBO.getCBOs();
      },
      maskCBO(CBO){
        if(!CBO)
          return ""
        
        return `${CBO.substring(0,4)}-${CBO.substring(4,6)}`
      },
      showSnackbar(msg, color, timeout) {
        if (this.snackbar.visible == true) this.resetSnackbar();
        this.snackbar.title = msg
        this.snackbar.color = color
        this.snackbar.visible = true
        this.snackbar.timeout = timeout
      },
      resetSnackbar() {
        this.snackbar.title = ""
        this.snackbar.color = ""
        this.snackbar.visible = false
        this.snackbar.timeout = 0
      },
      edit(item) {
        this.convention = item
        this.items = this.convention.items
        this.serviceStations = this.convention.serviceStations
        this.showTable = false
      },
      async addColletiveConvention() {
        this.convention = await this.conventionDefault;
        this.showTable = false;
      }, //addCity()
      async init() {
        this.conventions = [];
        this.convention = this.conventionDefault;
        this.items = [];
        await this.changeConventions();
      }, //init()
      async changeConventions() {
        this.conventions = await CollectiveConventionService.getAll();
      }, //changeConventions()
      async changeDataTable() {
        this.loading = true;
        try {
          this.items = await this.convention.items;
          this.showDataTable = true;
        } catch (error) {
          console.log(error);
        } finally {
          this.loading = false;
        }

        await this.changeServiceStations();
      }, //changeDataTable()
      async changeServiceStations() {
        this.loading = true;
        try {
          if (!this.convention.serviceStations)
            return (this.serviceStations = []);
          this.serviceStations = await this.convention.serviceStations;
        } catch (error) {
          console.log(error);
        } finally {
          this.loading = false;
        }
      }, //changeServiceStations()

      /* DIALOG ITEM START */
      async newItem() {
        this.loading = true;
        try {
          this.item = {};
          this.costs = [];
          this.showDialogItem = true;
        } catch (error) {
          console.log(error);
        } finally {
          this.loading = false;
        }
      }, //newItem()
      occupationText: item =>
        `${item.code.substring(0,4)}-${item.code.substring(4,6)}:  ${item.name}`,
      async addItem() {
        if (this.$refs.formDialogFunctionConvention.validate()) {
          if (this.isEdition) {
            this.convention.items[this.index] = this.item;
          } else {
            this.convention.items.push(this.item);
          }
          this.save();
          this.showDialogItem = false;
          this.isEdition = false
        }
      }, //addItem()
      cancelNewItem() {
        this.$refs.formDialogFunctionConvention.reset();
        this.showDialogItem = false;
      },
      validateOfQuantityItems() {
        if (this.convention.items.length > 0) {
          return true
        } else {
          this.quantityItemsError = true;
          return false
        }
      },
      editItem(item) {
        this.isEdition = true;
        this.index = this.convention.items.indexOf(item);
        this.item = Object.assign({}, item);

        if (!this.item.costs)
          this.item.costs = new Array()

        this.costs = this.item.costs;
        this.showDialogItem = true;
      }, //editItem()
      /* DIALOG ITEM END CODE */

      cancelNewConvention() {
        this.convention = this.conventionDefault;
        this.clearAllTests()
        this.serviceStations = []
        this.changeConventions()
        this.showTable = true;
        this.isEditing = false;
        this.quantityItemsError = false
      },
      /* COST DIALOG START CODE */
      newCost() {
        this.cost = {};
        this.$refs.formDialogCost.reset()
        this.showDialogCost = true;
      }, //newCost()
      addCost() {
        if (this.$refs.formDialogCost.validate()) {
          if (!this.costs)
            this.costs = new Array();
          this.costs.push(this.cost);
          this.item.costs = this.costs;
          this.showDialogCost = false;
        }
      }, //addCost()

      cancelNewCost() {
        this.$refs.formDialogCost.reset()
        this.showDialogCost = false
      }, //cancelNewCost()
      removeCost(item) {
        this.costs.splice(this.costs.indexOf(item));
      }, //removeCost()
      /* COST DIALOG END CODE */

      /* SERVICE STATION START CODE */

      newServiceStation() {
        this.loading = true;
        this.$refs.formServiceStation.reset()
        try {
          this.serviceStation = {}
          this.isEditingServiceStation = false
          this.showDialogServiceStation = true;
        } catch (error) {
          console.log(error);
        } finally {
          this.loading = false;
        }
      }, //newServiceStation()

      async addServiceStation() {

        if (this.$refs.formServiceStation.validate()) {
          this.showDialogServiceStation = false

          if (this.isEditingServiceStation) {
            this.serviceStations[this.indexServiceStationSelected] = this.serviceStation;
          } else {
            this.serviceStations.push(this.serviceStation);
          }
          this.convention.serviceStations = this.serviceStations;
        }


        //await this.save();
      }, //addServiceStation()//

      editServiceStation(item) {
        this.isEditingServiceStation = true
        this.indexServiceStationSelected = this.serviceStations.indexOf(item);
        this.showDialogServiceStation = true;
        this.serviceStation = Object.assign({}, item);
      }, //editServiceStation()//

      closeDialogServiceStation() {
        this.indexServiceStationSelected = -1
        this.$refs.formServiceStation.reset()
        this.showDialogServiceStation = false
        this.isEditingServiceStation = false
      },
      /* SERVICE STATION END CODE */

      async save() {
        this.validateOfQuantityItems()
        if (this.$refs.formConvention.validate() && this.validateOfQuantityItems()) {
          this.loading = true;

          try {
            if (this.convention._id) {
              let resp = await CollectiveConventionService.edit(this.convention);
              this.showSnackbar("Editado com sucesso!", "success", 5000);
              this.convention = resp.dataEdited
            } else {
              let resp = await CollectiveConventionService.save(this.convention);
              this.convention = resp.data
              this.showSnackbar("Salvo com sucesso!", "success", 5000);
            }
            this.serviceStations = this.convention.serviceStations
          } catch (error) {
            console.log(error);
            this.showSnackbar("Erro ao salvar registro!", "error", 5000);
          } finally {
            this.changeConventions()
            this.loading = false;
          }
        }

      }, //save()

      sumOfCosts(costs) {
        let sum = 0
        if (!costs)
          costs = new Array()
        costs.forEach(cost => {
          sum += cost.value
        });
        return sum;
      },

      clearAllTests() {
        this.$refs.formConvention.reset()
        this.$refs.formServiceStation.reset()
        this.$refs.formDialogFunctionConvention.reset()
        this.$refs.formDialogCost.reset()
      }
    }, // methods

    created() {
      this.init();
    } // created
  }; // export default

</script>
<style lang="css" scoped>
  >>>.currency-prepend-outer-icon>.v-input__control>.v-input__slot>.v-input__prepend-inner>.v-input__icon--prepend-inner>.v-icon {
    background-color: white !important;
    position: absolute;
    padding: 18px 5px;
    margin-right: 14px;
  }

</style>



// WEBPACK FOOTER //
// src/pages/CollectiveConvention.vue